import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import { RegistrationSteps } from '../Components/RegisterForm/registration_steps';
import Layout from '../Components/Layout';

const RegisterPage = ({ user, config, cmsSourceFirebase, actions, match }) => {
    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            <RegistrationSteps />
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterPage);
